import { render } from "./TheModalError.vue?vue&type=template&id=4b108398"
import script from "./TheModalError.vue?vue&type=script&lang=js"
export * from "./TheModalError.vue?vue&type=script&lang=js"

import "./TheModalError.vue?vue&type=style&index=0&id=4b108398&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__